<div class="breadcrumb-area">
    <h1>Reporte de Gastos</h1>
</div>

<div *ngIf="dashboardUrl" style="overflow: hidden; height: 580px; margin-bottom: 10px;">
    <iframe
        [src]="dashboardUrl"
        width="100%"
        height="600px"
        frameborder="0"
        allowfullscreen
        sandbox="allow-scripts allow-same-origin">
    </iframe>
</div>

<div *ngIf="dashboardProducts" style="overflow: hidden; height: 580px; margin-bottom: 10px;">
    <iframe
        [src]="dashboardProducts"
        width="100%"
        height="600px"
        frameborder="0"
        allowfullscreen
        sandbox="allow-scripts allow-same-origin">
    </iframe>
</div>

<div *ngIf="dashboardWarehouse" style="overflow: hidden; height: 580px;">
    <iframe
        [src]="dashboardWarehouse"
        width="100%"
        height="600px"
        frameborder="0"
        allowfullscreen
        sandbox="allow-scripts allow-same-origin">
    </iframe>
</div>